import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import Config from "../../config";
import {FiltersRow, InputRow} from "../../utils/table-utils";
import User from "../../../../services/user";

import * as U from "../../desktop-templates/menu-user";

export default class ProfilePage extends Component {
    state = {
        tabs: {
            current: '',
            list: {}
        }
    };

    componentWillMount() {
        this.state.tabs.current = this.props.tab || 'password';
        this.state.tabs.list = {
            profile: {
                label: window.Translation(msg`Dettagli`),
                description: window.Translation(msg`Informazioni account`)
            },
            password: {
                label: window.Translation(msg`Cambio Password`),
                description: window.Translation(msg`Cambio Password`)
            }
        };
    }

    switchTabs(newtab) {
        this.state.tabs.current = newtab;
        this.setState(this.state);
    }

    render() {
        return <div>
			<U.SubTabsContainer>
				{Object.entries(this.state.tabs.list).map(
					([key,item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)} >{item.label}</U.Tab>
				)}
			</U.SubTabsContainer>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            {this.state.tabs.current === 'password' && <PasswordChange />}
			{this.state.tabs.current === 'profile' && <ProfileDetails />}
        </div>;
    }
}

function ProfileDetails() {
	return <div class="px-3">
		<FiltersRow>
			<InputRow
				label={window.Translation(msg`Name`)}
				type="text"
				disabled={true}
				value={User.username()}
			/>
			<InputRow
				label={window.Translation(msg`Surname`)}
				type="text"
				disabled={true}
				value={User.username()}
			/>
		</FiltersRow>
	</div>
}

export class PasswordChange extends Component {
    state = {
        oldpass: '',
        newpass: '',
        confpass: '',
        errors: {}
    };

    componentWillMount() {
        this.state.errors = {
            'passwords-dont-match': window.Translation(msg`Le password non corrispondono`),
            'wrong-old-password': window.Translation(msg`La vecchia password non corrisponde`),
            'wrong-password': window.Translation(msg`La vecchia password non corrisponde`),
            'unauthorized': window.Translation(msg`Non sei autorizzato`),
            'wrong-user': window.Translation(msg`Account non identificato`),
        };
    }

    savePassword() {
        if (
            this.state.oldpass.trim() === ''
            || this.state.newpass.trim() === ''
            || this.state.confpass.trim() === ''
        ) {
            alert(window.Translation(msg`Assicurati di aver compilato tutti i campi prima di procedere`));
            return;
        }

        if (this.state.newpass !== this.state.confpass) {
            alert(this.state.errors['passwords-dont-match']);
            return;
        }

        Config.AccountApiClass.updateMyPassword(this.state.oldpass, this.state.newpass)
            .then(() => {
                this.setState({oldpass: '', newpass: '', confpass: ''});
                alert(window.Translation(msg`Password aggiornata con successo!`));
            })
            .catch(e => {
                alert(!!this.state.errors[e]? this.state.errors[e] : e);
            });
    }

    render() {
        return <div class="px-3">
            <form id="password-change" method="post" onSubmit={e => {e.preventDefault(); this.savePassword()}}>
                <FiltersRow>
                    <InputRow
                        label={window.Translation(msg`Vecchia Password`)}
                        type="password"
                        onInput={e => {
                            this.state.oldpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.oldpass}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow>
                    <InputRow
                        label={window.Translation(msg`Nuova Password`)}
                        type="password"
                        onInput={e => {
                            this.state.newpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.newpass}
                        required={true}
                    />
                    <InputRow
                        label={window.Translation(msg`Conferma Nuova Password`)}
                        type="password"
                        onInput={e => {
                            this.state.confpass = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.confpass}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow class="pt-5">
                    <input
                        type="submit"
                        class="px-4 py-2 sm:ml-5 bg-kobaaccent-400 text-black rounded m-auto"
                        value={window.Translation(msg`Cambia Password`)}
                    />
                </FiltersRow>
            </form>
        </div>;
    }
}